import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { 
  Box,
  Center,
  Flex,
  Heading,
  Spinner,
  useToast,
  VStack,
} from '@chakra-ui/react'
import { Form } from './Form'
import useSeasonChallengeTasks from './hooks/useSeasonChallengeTasks'
import { SeasonChallengeTaskFormData } from '@olagg/validation-schemas/seasonChallengeTask.schema'
import { AdminSeasonChallengeTask } from '@olagg/db-types'

const Edit = () => {
  const { season_id: seasonId, challenge_id: challengeId, id } = useParams<{ season_id: string, challenge_id: string, id: string }>()
  const navigate = useNavigate()
  const toast = useToast()
  const { getSeasonChallengeTask, updateSeasonChallengeTask, loading } = useSeasonChallengeTasks()

  const [task, setTask] = useState<AdminSeasonChallengeTask | null>(null)
  const [loadingTask, setLoadingTask] = useState(true)

  useEffect(() => {
    const loadSeasonChallengeTask = async () => {
      if (!id) return
      try {
        setLoadingTask(true)
        const taskData = await getSeasonChallengeTask(id)
        setTask(taskData)
      } catch (error) {
        toast({
          title: 'Error',
          description: 'No se pudo cargar la tarea',
          status: 'error',
          duration: 5000,
          isClosable: true,
        })
        navigate(`/seasons/${seasonId}/challenges/${challengeId}/tasks`)
      } finally {
        setLoadingTask(false)
      }
    }

    loadSeasonChallengeTask()
  }, [id])

  const onSubmit = async (data: SeasonChallengeTaskFormData) => {
    if (!task || !id) return

    try {
      await updateSeasonChallengeTask(id, data)
      toast({
        title: 'Tarea actualizada',
        description: 'La tarea ha sido actualizada exitosamente',
        status: 'success',
        duration: 5000,
        isClosable: true,
      })
      navigate(`/seasons/${seasonId}/challenges/${challengeId}/tasks`)
    } catch (error) {
      toast({
        title: 'Error',
        description: 'No se pudo actualizar la tarea',
        status: 'error',
        duration: 5000,
        isClosable: true,
      })
    }
  }

  const onCancel = () => {
    navigate(`/seasons/${seasonId}/challenges/${challengeId}/tasks`)
  }

  if (loadingTask) {
    return (
      <Flex justify="center" align="center" h="200px">
        <Spinner size="lg" />
      </Flex>
    )
  }

  if (!task) {
    return (
      <Box>
        <Heading size="md" color="red.500">
          Tarea no encontrada
        </Heading>
      </Box>
    )
  }

  return (
    <Center w={'full'} pb={4}>
      <VStack color={'white'} w={'full'}>
        <Heading my={2}>Editar Tarea</Heading>

        <Form
          initialData={task}
          onSubmit={onSubmit}
          onCancel={onCancel}
          loading={loading}
          isEdit={true}
        />
      </VStack>
    </Center>
  )
}

export default Edit;